export default class AreaWorkController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/areaWork/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/delete', 'post', params, axiosOption, httpOption);
  }

  static startOnlyFlowAreaWork (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/startOnly/flowAreaWork', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyFlowAreaWork (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/startWithBusinessKey/flowAreaWork', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskFlowAreaWork (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/startAndTakeUserTask/flowAreaWork', 'post', params, axiosOption, httpOption);
  }

  static startAndSaveDraftFlowAreaWork (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/startAndSaveDraft/flowAreaWork', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskFlowAreaWork (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/submitUserTask/flowAreaWork', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataFlowAreaWork (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/viewTaskBusinessData/flowAreaWork', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataFlowAreaWork (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/viewHistoricTaskBusinessData/flowAreaWork', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderFlowAreaWork (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/areaWork/listWorkOrder/flowAreaWork', 'post', params, axiosOption, httpOption);
  }
}
